import React from 'react'

const initialState = {
  isOpenCreatingRoleDialog: false,
}

export const useCreatingRoleDialogState = () => {
  const context = React.useContext(CreatingDialogState)
  if (context === undefined) {
    throw new Error(
      'useCreatingRoleDialogState must be used within a CreatingDialogStateProvider',
    )
  }
  return context
}

export const CreatingDialogStateProvider = ({ children }) => {
  const [state, setState] = React.useState(initialState)
  return (
    <CreatingDialogState.Provider value={{ state, setState }}>
      {children}
    </CreatingDialogState.Provider>
  )
}

export const CreatingDialogState = React.createContext()
